import mixpanel from 'mixpanel-browser';
import { SignupState } from 'domains/signup/signupFlow/signupMachine';
import { ScreenerState } from 'domains/signup/screener/screenerMachine';
import { InsuranceEntryState } from 'domains/signup/insurance/insuranceMachine';
import { ScheduleState } from 'domains/signup/consultationSchedule/scheduleMachine';
import { ContactInfoState } from 'domains/signup/contactInfo/contactInfoMachine';
import { TypeTherapyScreenerV2 } from 'types/contentful';

const SCREENER_EVENT_PREFIX = 'Viewed - Screener -';
const SIGNUP_EVENT_PREFIX = 'Viewed - Sign up Flow 3.0 -';

const TRACKED_SIGNUP_STATES: {
  [k in SignupState | InsuranceEntryState | ScheduleState | ContactInfoState]?: string;
} = {
  enterTarget: 'Client type (child/adult)',
  enterCommunicationConcerns: 'Concerns',

  // contact info
  enterState: 'State',
  enterName: 'Name',
  enterPhoneNumber: 'Phone',
  enterEmail: 'Email',

  // insurance info
  enterUseInsurance: 'Use insurance?',
  enterInsuranceType: 'Insurance Type',
  enterMedicaidProvider: 'Medicaid Provider',
  insuranceNotInNetwork: 'Insurance not in network',

  // consultation schedule
  enterConsultationDate: 'Schedule free consultation',
  confirmConsultationDate: 'Confirm Schedule',

  // internal states
  creatingLead: 'Creating lead (dev)',
  leadCreationError: 'Lead creation failed (dev)',
  loadingAvailableDates: 'Loading schedule dates (dev)',
  loadingDatesFailed: 'Loading schedule dates failed (dev)',
  schedulingConsultation: 'Saving consultation schedule (dev)',
  signupComplete: 'Signup complete, redirecting (dev)',
};

const TRACKED_SCREENER_STATES: {
  [k in ScreenerState]?: string;
} = {
  landingPage: 'Screener Landing Page',
  enterTarget: 'Client type (child/adult)',
  enterDob: 'DOB',
  runningScreenerQuestions: 'Start screener questions',
  finished: 'Show Results',
};

export const signupStateChangeListener = (
  currentState: SignupState | InsuranceEntryState | ScheduleState | ContactInfoState,
) => {
  const mappedEvent = TRACKED_SIGNUP_STATES[currentState];

  if (mappedEvent) {
    mixpanel.track(`${SIGNUP_EVENT_PREFIX} ${mappedEvent}`);
  }
};

export const screenerStateChangeListener = (currentState: ScreenerState) => {
  const mappedEvent = TRACKED_SCREENER_STATES[currentState];

  if (mappedEvent) {
    mixpanel.track(`${SCREENER_EVENT_PREFIX} ${mappedEvent}`);
  }
};

export const getTrackEventForScreenerQuestion = (screener: TypeTherapyScreenerV2, questionIndex: number): string => {
  return `${SCREENER_EVENT_PREFIX} ${screener.fields.ageRangeTitle} - Step ${questionIndex + 1}`;
};
